// Image URL mappings — Fenco Digital
// Local brand assets in /public/brand + Unsplash photos (free for commercial use)

export const IMG = {
  // Lifestyle — person using a card terminal (used across hero and background scenes)
  cardInUseHero: "/brand/dojo-cafe.png",
  cardInUseCafe: "/brand/dojo-cafe.png",
  cardInUseRetail: "/brand/dojo-cafe.png",
  cardTerminalHero: "/brand/dojo-cafe.png",

  // Local / NI feel (Unsplash)
  niCity: "https://images.unsplash.com/photo-1518481612222-68bbe828ecd1?auto=format&fit=crop&w=1400&q=80",

  // Funding success stories
  storyButcher: "https://images.unsplash.com/photo-1607623814075-e51df1bdc82f?auto=format&fit=crop&w=1200&q=80",
  storyCafe: "https://images.unsplash.com/photo-1554118811-1e0d58224f24?auto=format&fit=crop&w=1200&q=80",
  storyBarber: "https://images.unsplash.com/photo-1503951914875-452162b0f3f1?auto=format&fit=crop&w=1200&q=80",

  // POS Systems page (modern generic Unsplash)
  posHero: "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?auto=format&fit=crop&w=1600&q=80",
  posTerminal: "https://images.unsplash.com/photo-1556742044-3c52d6e88c62?auto=format&fit=crop&w=1200&q=80",
  posRetail: "https://images.unsplash.com/photo-1556740738-b6a63e27c4df?auto=format&fit=crop&w=1200&q=80",
  posCounter: "https://images.unsplash.com/photo-1556740749-887f6717d7e4?auto=format&fit=crop&w=1200&q=80",
  posContactless: "https://images.unsplash.com/photo-1556742059-47b93231f536?auto=format&fit=crop&w=1200&q=80",

  // Website Design page
  webHero: "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?auto=format&fit=crop&w=1600&q=85",
  webDesk: "https://images.unsplash.com/photo-1522542550221-31fd19575a2d?auto=format&fit=crop&w=1200&q=85",
  webWireframe: "https://images.unsplash.com/photo-1587440871875-191322ee64b0?auto=format&fit=crop&w=1200&q=85",

  // App Design page
  appHero: "https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?auto=format&fit=crop&w=1600&q=85",
  appMockup: "https://images.unsplash.com/photo-1526498460520-4c246339dccb?auto=format&fit=crop&w=1200&q=85",
  appPhone: "https://images.unsplash.com/photo-1512486130939-2c4f79935e4f?auto=format&fit=crop&w=1200&q=85",
};
